export default "dist/images/components-icon-controls-outlined.fcce4ac.png";